import { lazy } from "react";
import { RoutesLink } from "@/utility/RouteLinks";
import { permissionKeys } from "@/utility/helper";
import type { IPrivateRoutes } from "../types";

// Department
const Department = lazy(() => import("@/pages/HRMS/Department/Department"));
const AddDepartment = lazy(
  () => import("@/pages/HRMS/Department/AddDepartment"),
);

// Branch
const Branch = lazy(() => import("@/pages/HRMS/Branch/Branch"));
const AddBranch = lazy(() => import("@/pages/HRMS/Branch/AddBranch"));

// Company
const Company = lazy(() => import("@/pages/HRMS/Company/Company"));
const CreateCompany = lazy(() => import("@/pages/HRMS/Company/CreateCompany"));

// Shift & Time
const ShiftAndTime = lazy(
  () => import("@/pages/HRMS/ShiftAndTime/ShifAndTime"),
);
const AddShiftAndTime = lazy(
  () => import("@/pages/HRMS/ShiftAndTime/AddShiftAndTime"),
);
const ShiftAndTimeDetail = lazy(
  () => import("@/pages/HRMS/ShiftAndTime/ShiftAndTimeDetail"),
);

// Designation
const Designation = lazy(() => import("@/pages/HRMS/Designation/Designation"));
const AddDesignation = lazy(
  () => import("@/pages/HRMS/Designation/AddDesignation"),
);

// Site & Campus
const Site = lazy(() => import("@/pages/HRMS/Site/Site"));
const AddSite = lazy(() => import("@/pages/HRMS/Site/AddSite"));
const CampusConfig = lazy(() => import("@/pages/HRMS/Campus/CampusConfig"));
const AddCampus = lazy(() => import("@/pages/HRMS/Campus/AddCampus"));

// Application
const Application = lazy(() => import("@/pages/HRMS/Applications/Application"));
const AddApplication = lazy(
  () => import("@/pages/HRMS/Applications/AddApplication"),
);

// Leave Settings
const LeaveSetting = lazy(
  () => import("@/pages/HRMS/HrmsSettings/LeaveSettings/LeaveSettings"),
);
const AddLeaveSetting = lazy(
  () => import("@/pages/HRMS/HrmsSettings/LeaveSettings/AddLeaveSetting"),
);

// Asset Management
const Asset = lazy(
  () => import("@/pages/HRMS/HrmsSettings/Assets settings/Asset"),
);
const CreateAsset = lazy(
  () => import("@/pages/HRMS/HrmsSettings/Assets settings/CreateAsset"),
);
const AssetDetail = lazy(
  () => import("@/pages/HRMS/HrmsSettings/Assets settings/AssetDetail"),
);
const EmployeeAsset = lazy(() => import("@/pages/HRMS/Asset/EmployeeAsset"));
const AssetRequest = lazy(
  () => import("@/pages/HRMS/HrmsSettings/Assets settings/AssetRequest"),
);

// Transfer
const Transfer = lazy(
  () => import("@/pages/HRMS/HrmsSettings/Transfer/Transfer"),
);

// Company Documents
const CreateCompanyDocument = lazy(
  () => import("@/pages/HRMS/CompanyDocument/CreateConpanyDocument"),
);
const CompanyDocument = lazy(
  () => import("@/pages/HRMS/CompanyDocument/CompanyDocument"),
);
const ViewCompanyDocument = lazy(
  () => import("@/pages/HRMS/CompanyDocument/ViewCompanyDocument"),
);

// Holiday
const Holiday = lazy(
  () => import("@/pages/HRMS/HrmsSettings/HolidaySettings/Holiday"),
);
const AddHoliday = lazy(
  () => import("@/pages/HRMS/HrmsSettings/HolidaySettings/AddHoliday"),
);

// Settings
const Setting = lazy(() => import("@/pages/HRMS/Setting/Setting"));

export const settingsRoutes: IPrivateRoutes[] = [
  // Department
  {
    path: RoutesLink.superAdminDepartment,
    route: <Department />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: RoutesLink.addDepartment,
    route: <AddDepartment />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: `${RoutesLink.editDepartment}/:id`,
    route: <AddDepartment />,
    accessKey: permissionKeys.hrmSetting,
  },

  // Branch
  {
    path: RoutesLink.superAdminBranch,
    route: <Branch />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: RoutesLink.addBranch,
    route: <AddBranch />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: `${RoutesLink.editBranch}/:id`,
    route: <AddBranch />,
    accessKey: permissionKeys.hrmSetting,
  },

  // Company
  {
    path: RoutesLink.company,
    route: <Company />,
    accessKey: permissionKeys.company,
  },
  {
    path: RoutesLink.createCompany,
    route: <CreateCompany />,
    accessKey: permissionKeys.company,
  },
  {
    path: `${RoutesLink.editCompany}/:id`,
    route: <CreateCompany />,
    accessKey: permissionKeys.company,
  },

  // Shift & Time
  {
    path: RoutesLink.shiftAndTime,
    route: <ShiftAndTime />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: RoutesLink.addShiftAndTime,
    route: <AddShiftAndTime />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: `${RoutesLink.editShiftAndTime}/:id`,
    route: <AddShiftAndTime />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: `${RoutesLink.viewShiftAndTime}/:id`,
    route: <ShiftAndTimeDetail />,
    accessKey: permissionKeys.hrmSetting,
  },

  // Designation
  {
    path: RoutesLink.superAdminDesignation,
    route: <Designation />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: RoutesLink.addDesignation,
    route: <AddDesignation />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: `${RoutesLink.editDesignation}/:id`,
    route: <AddDesignation />,
    accessKey: permissionKeys.hrmSetting,
  },

  // Site
  {
    path: RoutesLink.superAdminSite,
    route: <Site />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: RoutesLink.addSite,
    route: <AddSite />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: `${RoutesLink.editSite}/:id`,
    route: <AddSite />,
    accessKey: permissionKeys.hrmSetting,
  },

  // Campus
  {
    path: RoutesLink.superAdminCampus,
    route: <CampusConfig />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: RoutesLink.addCampus,
    route: <AddCampus />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: `${RoutesLink.editCampus}/:id`,
    route: <AddCampus />,
    accessKey: permissionKeys.hrmSetting,
  },

  // Applications
  {
    path: RoutesLink.superAdminApplication,
    route: <Application />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: RoutesLink.addApplication,
    route: <AddApplication />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: `${RoutesLink.editApplication}/:id`,
    route: <AddApplication />,
    accessKey: permissionKeys.hrmSetting,
  },

  // Leave Settings
  {
    path: RoutesLink.leaveSetting,
    route: <LeaveSetting />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: RoutesLink.addLeaveSetting,
    route: <AddLeaveSetting />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: `${RoutesLink.editLeaveSetting}/:id`,
    route: <AddLeaveSetting />,
    accessKey: permissionKeys.hrmSetting,
  },

  // Asset Management
  {
    path: RoutesLink.assetList,
    route: <Asset />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: RoutesLink.addAsset,
    route: <CreateAsset />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: `${RoutesLink.editAsset}/:id`,
    route: <CreateAsset />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: `${RoutesLink.assetDetail}/:id`,
    route: <AssetDetail />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: RoutesLink.employeeAsset || "/employee-asset",
    route: <EmployeeAsset />,
  },
  {
    path: RoutesLink.assetRequests || "/asset-requests",
    route: <AssetRequest />,
    accessKey: permissionKeys.hrmSetting,
  },

  // Transfer
  {
    path: RoutesLink.transfer,
    route: <Transfer />,
  },

  // Company Documents
  {
    path: RoutesLink.createCompanyDocument,
    route: <CreateCompanyDocument />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: `${RoutesLink.editCompanyDocument}/:id`,
    route: <CreateCompanyDocument />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: `${RoutesLink.companyDocumentDetail}/:id`,
    route: <ViewCompanyDocument />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: RoutesLink.companyDocument,
    route: <CompanyDocument />,
    accessKey: permissionKeys.hrmSetting,
  },

  // Holiday (Admin)
  {
    path: RoutesLink.superAdminHoliday,
    route: <Holiday isAdmin={true} />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: RoutesLink.addHoliday,
    route: <AddHoliday />,
    accessKey: permissionKeys.hrmSetting,
  },
  {
    path: `${RoutesLink.editHoliday}/:id`,
    route: <AddHoliday />,
    accessKey: permissionKeys.hrmSetting,
  },

  // Settings
  {
    path: RoutesLink.documentSetting,
    route: <Setting />,
  },
];
